import { Button } from "@/components/ui/baseUi/button"
import { cn } from "@/modules/lib/utils"
import { ArrowDown01Icon, ArrowDownAZIcon, ArrowUp01Icon, ArrowUpAZIcon, ArrowUpDownIcon } from "lucide-react"

export const datatableThVariants = {
  default: "default",
  noSort: "noSort",
  numberSortAsc: "numberSortAsc",
  numberSortDesc: "numberSortDesc",
  stringSortAsc: "stringSortAsc",
  stringSortDesc: "stringSortDesc",
} as const
export type DatatableThVariant = (typeof datatableThVariants)[keyof typeof datatableThVariants]

type Props = React.ComponentProps<"div"> & {
  title: string
  variant?: DatatableThVariant
  onSortAsc?: () => void
  onSortDesc?: () => void
}

export function HeaderTemplate({ title, variant = "noSort", onSortAsc, onSortDesc, className, ...props }: Props) {
  if (variant === "noSort") return title

  const handleSortClick = () => {
    if ((variant === "numberSortAsc" || variant === "stringSortAsc") && onSortDesc) {
      onSortDesc()
    } else if ((variant === "numberSortDesc" || variant === "stringSortDesc" || variant === "default") && onSortAsc) {
      onSortAsc()
    }
  }

  return (
    <div className={cn("flex flex-row items-center justify-start gap-3", className)} {...props}>
      {title}

      <Button
        variant="ghost"
        size="iconSm"
        className={cn({ "text-(--button-ghost-text-disabled)": variant === "default" })}
        onClick={handleSortClick}
      >
        {variant === "default" && <ArrowUpDownIcon color="currentColor" />}
        {variant === "numberSortAsc" && <ArrowDown01Icon color="currentColor" />}
        {variant === "numberSortDesc" && <ArrowUp01Icon color="currentColor" />}
        {variant === "stringSortAsc" && <ArrowDownAZIcon color="currentColor" />}
        {variant === "stringSortDesc" && <ArrowUpAZIcon color="currentColor" />}
      </Button>
    </div>
  )
}
